import React from "react";
import { withTranslation } from "react-i18next";
import {OrangeButton} from "../../shared/components/Buttons";

const CreditCardForm = ({ fields, t }) => (
    <form
        className="payment-type-bloc overflow-x-hidden"
        method="POST"
        action="https://paiement.systempay.fr/vads-payment/"
    >
        <div className="payment-text">
            <span className="cards-title">{t("followup.accepted_cards")} : </span>
            <br />
            <ul className="cb-types my-2">
                <li className="cb-type">
                    <img src="/assets/img/icons/payment/cb.png" />
                </li>
                <li className="cb-type">
                    <img src="/assets/img/icons/payment/visa.png" />
                </li>
                <li className="cb-type">
                    <img src="/assets/img/icons/payment/visa-electron.png" />
                </li>
                <li className="cb-type">
                    <img src="/assets/img/icons/payment/mastercard.png" />
                </li>
                <li className="cb-type">
                    <img src="/assets/img/icons/payment/maestro.png" />
                </li>
                <li className="cb-type">
                    <img src="/assets/img/icons/payment/e-cb.png" />
                </li>
            </ul>
            <p className="my-1">{t("followup.card_payment_information")}</p>
        </div>

        {Object.keys(fields).map((key) => (
            <input key={key} type="hidden" name={key} value={fields[key]} />
        ))}

        {/*<input type="hidden" name="vads_cust_name" value=""/>*/}
        {/*<input type="hidden" name="vads_cust_address" value=""/>*/}
        {/*<input type="hidden" name="vads_cust_zip" value=""/>*/}
        {/*<input type="hidden" name="vads_cust_city" value=""/>*/}
        {/*<input type="hidden" name="vads_cust_city" value=""/>*/}

        <OrangeButton icon="external-link" type="submit" className="btn-warning btn-lg mt-5">
            {t("followup.card_pay")}
        </OrangeButton>
    </form>
);

export default withTranslation()(CreditCardForm);
